import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { usePrevious } from '@beef/react';
import styles from "./styles.pcss";
var cnSegmentedControl = cnBem('segmented-control', styles);
var SegmentedControlRender = function SegmentedControlRender(_ref, ref) {
  var _ref2;
  var activeIndex = _ref.activeIndex,
    children = _ref.children,
    itemsLength = _ref.itemsLength;
  var previousActiveIndex = usePrevious(activeIndex);
  return /*#__PURE__*/React.createElement("div", {
    className: cnSegmentedControl({
      withPointer: activeIndex >= 0,
      pointerMovable: previousActiveIndex !== -1 && activeIndex !== -1
    }),
    ref: ref,
    style: (_ref2 = {}, _defineProperty(_ref2, '--segmented-control-active', "".concat(activeIndex !== -1 ? activeIndex : previousActiveIndex)), _defineProperty(_ref2, '--segmented-control-count', "".concat(itemsLength)), _ref2),
    "data-t-id": "Tabs-SegmentedContainer"
  }, children);
};
export var SegmentedContainer = /*#__PURE__*/forwardRef(SegmentedControlRender);